import { FACE_CONFIG, FACE_ORDER } from './cube-config.js';

export const ORDER_4X4 = 4;
export const STICKERS_PER_FACE_4X4 = 16;
export const TOTAL_STICKERS_4X4 = 96;
export const CENTER_INDICES_4X4 = Object.freeze([5, 6, 9, 10]);
export const GRID_COORDINATES_4X4 = Object.freeze([-3, -1, 1, 3]);

export { FACE_CONFIG, FACE_ORDER };

export function assertStickerIndex4x4(index) {
  if (!Number.isInteger(index) || index < 0 || index >= STICKERS_PER_FACE_4X4) {
    throw new RangeError(`4×4 贴纸索引必须是 0–15，收到：${index}`);
  }
}

export function indexToGrid4x4(index) {
  assertStickerIndex4x4(index);
  return Object.freeze({ row: Math.floor(index / ORDER_4X4), col: index % ORDER_4X4 });
}

export function gridToIndex4x4(row, col) {
  if (![row, col].every(Number.isInteger) || row < 0 || row >= ORDER_4X4 || col < 0 || col >= ORDER_4X4) {
    throw new RangeError(`4×4 行列坐标必须在 0–3 内，收到：${row}, ${col}`);
  }
  return row * ORDER_4X4 + col;
}

export function stickerPosition4x4(face, index, radius = 2.03, spacing = 1) {
  const { row, col } = indexToGrid4x4(index);
  const { normal, right, down } = FACE_CONFIG[face];
  const rowOffset = row - 1.5;
  const colOffset = col - 1.5;
  return normal.map((axis, dimension) => (
    axis * radius
    + right[dimension] * colOffset * spacing
    + down[dimension] * rowOffset * spacing
  ));
}

